import { apiRequest } from './api';

export interface BoostRequestPayload {
  userEmail?: string | null;
  eventId?: string;
  buildingId?: string;
  actionType: 'buy' | 'sell';
  buildingAddress: string;
}

/**
 * Send a visibility-boost request to the backend concierge flow
 * (POST /boost-listing → Slack + support email + boost_requests doc).
 * The team follows up manually with a payment link; price rides along
 * for payload parity with the legacy callers.
 */
export async function postBoostRequest(payload: BoostRequestPayload): Promise<void> {
  await apiRequest('/boost-listing', {
    method: 'POST',
    body: { ...payload, price: 49.9 },
  });
}
